
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {
    "buildId": "82128dc1-0c81-4790-bdf0-3a5e0ccf8782"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/webapp/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
